import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CmsConfig, I18nModule, provideDefaultConfig } from "@spartacus/core";
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, ParagraphComponent } from "@spartacus/storefront";
import { KbManageRegistrationComponent } from "./kb-manage-registration.component";
import { KbMyAccountLeftSideNavModule } from "../../kb-myAccount/my-account-left-sidenav/my-account-left-sidenav.module";
import { KbPaginationModule } from "../../kb-pagination/kb-pagination/kb-pagination.module";

@NgModule({
 imports:[
  CommonModule,
  PageLayoutModule,
  OutletModule,
  OutletRefModule,
  PageSlotModule,
  I18nModule,  
  KbPaginationModule,
  KbMyAccountLeftSideNavModule
 ],
 providers:[ 
  ],
 declarations:[KbManageRegistrationComponent]
})
export class KbManageRegistrationModule {

}
